import * as React from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { bindActionCreators } from "redux";
import PlacesAutocomplete, { geocodeByAddress } from "react-places-autocomplete";
import "../../../assets/sass/widgets/typeAhead.scss";
import Dropdown from "../../components/dropdown";
import DatePicker from "../../components/DatePicker";
import * as SUBMITTED_LIST_ACTIONS from "./actionCreators";

import { WARRANTIES_STATUS, COUNTRIES } from "./constant";
import { dateFormatter } from "../../utils/utils";
interface IWarrantiesFilterProps {
    contractorSettings: any;
    submittedListActions: any;
    stateOrProvinceList: any;
    screenResolution: Record<string, number>;
}
class WarrantiesFilters extends React.Component<IWarrantiesFilterProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: undefined,
            toDate: undefined,
            country: "USA",
            state: "",
            city: "",
            zipcode: "",
            address1: "",
            warrantyStatus: undefined,
            warrantyID: "",
            errors: null,
            filters: {},
            isSearchBtnClicked: false,
            isResetBtnClicked: false,
        };
    }
    componentDidUpdate({}, prevState): void {
        if (
            (!!this.state.isSearchBtnClicked || !!this.state.isResetBtnClicked) &&
            JSON.stringify(prevState.filters) !== JSON.stringify(this.state.filters)
        ) {
            this.setState({
                isSearchBtnClicked: false,
                isResetBtnClicked: false,
            });

            const { fetchSubmittedWarrentyList } = this.props.submittedListActions;
            fetchSubmittedWarrentyList(this.state.filters);
        }
    }
    updateWarrantyStatus = (value) => {
        this.setState({ warrantyStatus: value, isSearchBtnClicked: false, isResetBtnClicked: false });
    };
    updateCountrySelection = (value) => {
        this.setState({ country: value, state: "", isSearchBtnClicked: false, isResetBtnClicked: false });
    };
    changeCity = (e) => {
        this.setState({
            city: e.target.value,
            isSearchBtnClicked: false,
            isResetBtnClicked: false,
        });
    };
    changeZipcode = (e) => {
        this.setState({
            zipcode: e.target.value,
            isSearchBtnClicked: false,
            isResetBtnClicked: false,
        });
    };
    updateStateSelection = (value) => {
        this.setState({
            state: value,
            isSearchBtnClicked: false,
            isResetBtnClicked: false,
        });
    };
    fromDateChange = (date) => {
        this.setState({
            fromDate: date,
            toDate: dateFormatter(new Date().toDateString()),
            isSearchBtnClicked: false,
            isResetBtnClicked: false,
        });
    };

    toDateChange = (date) => {
        this.setState({ toDate: date, isSearchBtnClicked: false, isResetBtnClicked: false });
    };
    changeWarrantyId = (e) => {
        const value = e.target.value;
        const reg = new RegExp("^([0-9]+,?)*$");
        if (reg.test(value)) {
            this.setState({
                warrantyID: value,
            });
        }
    };
    applyFiltersHandler = () => {
        if (this.state.fromDate && !this.state.toDate) {
            return undefined;
        }
        const filtersObj = {
            warrantyStatus: this.state.warrantyStatus,
            warrantyID: this.state.warrantyID,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            country: this.state.country,
            state: this.state.state,
            city: this.state.city,
            zipcode: this.state.zipcode,
            address: this.state.address1,
        };
        Object.keys(filtersObj).forEach((key) => {
            if (!filtersObj[key]) {
                delete filtersObj[key];
            }
        });
        this.setState({
            isSearchBtnClicked: true,
            filters: filtersObj,
        });
    };
    resetFiltersHandler = () => {
        this.setState({
            isResetBtnClicked: true,
            warrantyStatus: undefined,
            fromDate: undefined,
            toDate: undefined,
            warrantyID: "",
            country: "",
            state: "",
            city: "",
            zipcode: "",
            address1: "",
            filters: {},
        });
    };
    renderStartDateDatePicker = () => {
        return (
            <DatePicker
                placeHolder="From Date"
                id="fromDate"
                selectedValue={this.state.fromDate}
                onChange={this.fromDateChange}
                disabled={false}
            />
        );
    };
    renderEndDateDatePicker = () => {
        const { fromDate, toDate, isSearchBtnClicked } = this.state;
        return (
            <>
                <DatePicker
                    placeHolder="To Date"
                    fromDate={new Date(this.state.fromDate)}
                    disabled={!this.state.fromDate}
                    maxDays={500}
                    isError={isSearchBtnClicked && !toDate}
                    id="toDate"
                    selectedValue={this.state.toDate}
                    onChange={this.toDateChange}
                />
                {isSearchBtnClicked && fromDate && !toDate && (
                    <div>
                        <span className="text-danger input-error-msg">Please select To Date</span>
                    </div>
                )}
            </>
        );
    };

    formatAddress = (addressComponent) => {
        const address = {
            address1: "",
            neighborhood: "",
            subLocality: "",
            locality: "",
            state: "",
            city: "",
            zip: "",
        };
        if (!addressComponent) {
            return address;
        }
        addressComponent.forEach((value) => {
            const { types } = value;
            const longName = value.long_name;
            const shortName = value.short_name;
            const isStreetName = types.indexOf("street_number") > -1;
            const isRoute = types.indexOf("route") > -1;
            const subLocality = types.indexOf("sublocality_level_1") > -1;
            const isNeighborhoodAddress = types.indexOf("neighborhood") > -1;
            const isLocality = types.indexOf("locality") > -1;
            const isState = types.indexOf("administrative_area_level_1") > -1;
            const isPostalCode = types.indexOf("postal_code") > -1;

            if (isStreetName) address.address1 = longName;
            if (isRoute) address.address1 = `${address.address1 || ""} ${longName}`;
            if (isNeighborhoodAddress) address.neighborhood = longName;
            if (subLocality) address.subLocality = longName;
            if (isLocality) address.locality = longName;
            if (isState) address.state = shortName;
            if (isPostalCode) address.zip = longName;
        });
        const { neighborhood, subLocality, locality } = address;
        return {
            ...address,
            city: locality || subLocality || neighborhood,
        };
    };

    handleSelect = (value) => {
        let addressComponents = null;
        geocodeByAddress(value).then((results) => {
            [addressComponents] = results;
            const formatedAddress = this.formatAddress(addressComponents.address_components);
            this.setState({
                address1: `${formatedAddress.address1}, ${formatedAddress.city}, ${formatedAddress.state}, ${formatedAddress.zip}`,
                city: formatedAddress.city,
                state: formatedAddress.state,
                zipcode: formatedAddress.zip,
            });
        });
    };
    handleAddressChange = (value) => {
        this.setState({
            address1: value,
        });
    };

    renderTypeAhead = () => {
        return (
            <PlacesAutocomplete
                value={this.state.address1}
                onChange={this.handleAddressChange}
                onSelect={this.handleSelect}
                searchOptions={{
                    componentRestrictions: { country: this.state.country },
                    types: ["address"],
                }}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                    <div className="inputbox-rectangle">
                        <input
                            id="address-id"
                            className="gaf-inputbox"
                            placeholder="Enter Street Address"
                            {...getInputProps()}
                        />
                        <div>
                            {loading ? <div>...</div> : null}
                            {suggestions.map((suggestion, index) => {
                                const style = {
                                    backgroundColor: suggestion.active ? "#dedede" : "white",
                                    borderLeft: "1px solid #b7b7b7",
                                    borderRight: "1px solid #b7b7b7",
                                    padding: "10px",
                                };
                                return (
                                    <div key={index} className="suggestion-div">
                                        <div {...getSuggestionItemProps(suggestion, { style })}>
                                            {suggestion.description}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        );
    };
    render() {
        const isMobileView = this.props.screenResolution.width < 768;
        return (
            <div className="submitted-tab-filters">
                <Row className="mb-1">
                    <Col md={3}>
                        <div className="filters-title-label">
                            <label>Country</label>
                        </div>
                        <Dropdown
                            menuItems={COUNTRIES}
                            onChangeReportType={this.updateCountrySelection}
                            isError={false}
                            selectedOption={this.state.country}
                            resetDropdown={!this.state.country}
                        />
                    </Col>
                    <Col md={8}>
                        <div className="filters-title-label">
                            <label>Address</label>
                        </div>
                        <div className="warranty-id-input">{this.renderTypeAhead()}</div>
                    </Col>
                    {!isMobileView && (
                        <Col md={1} className="d-flex align-items-end justify-content-end">
                            <button
                                className="reset-filter-btn"
                                id="reset-filter-btn"
                                onClick={this.resetFiltersHandler}
                            >
                                Clear
                            </button>
                        </Col>
                    )}
                </Row>
                <Row className="mb-1 d-none">
                    <Col md={1} className="d-flex align-items-center">
                        <div className="filters-title-label">
                            <label></label>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="warranty-id-input">
                            <input
                                className="gaf-inputBox"
                                type="text"
                                placeholder="Enter City"
                                value={this.state.city}
                                onChange={(e) => this.changeCity(e)}
                            />
                        </div>
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            menuItems={this.props.stateOrProvinceList[this.state.country]}
                            onChangeReportType={this.updateStateSelection}
                            isError={false}
                            selectedOption={this.state.state}
                            resetDropdown={!this.state.state}
                        />
                    </Col>
                    <Col md={3}>
                        <div className="warranty-id-input">
                            <input
                                className="gaf-inputBox"
                                type="text"
                                placeholder="Enter Zipcode"
                                value={this.state.zipcode}
                                onChange={(e) => this.changeZipcode(e)}
                            />
                        </div>
                    </Col>
                </Row>
                <Row className="mb-1 pt-2">
                    <Col md={3} className="d-none">
                        <div className="filters-title-label">
                            <label>Warranty Status</label>
                        </div>
                        <Dropdown
                            menuItems={WARRANTIES_STATUS}
                            onChangeReportType={this.updateWarrantyStatus}
                            isError={false}
                            selectedOption={this.state.warrantyStatus}
                            resetDropdown={!this.state.warrantyStatus}
                        />
                    </Col>
                    <Col md={3}>
                        <div className="filters-title-label">
                            <label>Warranty / Shopping Cart #</label>
                        </div>
                        <div className="warranty-id-input">
                            <input
                                className="gaf-inputBox"
                                type="text"
                                placeholder="Enter warranty or Shopping Cart ID"
                                value={this.state.warrantyID}
                                onChange={(e) => this.changeWarrantyId(e)}
                            />
                        </div>
                    </Col>
                    <Col md={8}>
                        <div className="filters-title-label">
                            <label>Date</label>
                        </div>
                        <div className="date-filters-widget">
                            <div className="date-filter-calender">{this.renderStartDateDatePicker()}</div>
                            <div className="mr-2 ml-2">to</div>
                            <div className="date-filter-calender">{this.renderEndDateDatePicker()}</div>
                        </div>
                    </Col>
                    {!isMobileView && (
                        <Col md={1} className="d-flex align-items-end justify-content-end">
                            <button
                                className="apply-filter-btn"
                                id="apply-filter-btn"
                                onClick={this.applyFiltersHandler}
                            >
                                Search
                            </button>
                        </Col>
                    )}
                </Row>
                {isMobileView && (
                    <Row className="mb-1 pt-2">
                        <Col md={12} className="d-flex align-items-center justify-content-end">
                            <button
                                className="reset-filter-btn"
                                id="reset-filter-btn"
                                onClick={this.resetFiltersHandler}
                            >
                                Clear
                            </button>
                            <button
                                className="apply-filter-btn"
                                id="apply-filter-btn"
                                onClick={this.applyFiltersHandler}
                            >
                                Search
                            </button>
                        </Col>
                    </Row>
                )}
            </div>
        );
    }
}
export function mapStateToProps(state) {
    return {
        screenResolution: state.globalInfo.screenResolution,
        contractorSettings: state.dynamicFormInfo.contractorSettings || {},
        stateOrProvinceList: state.submittedListInfo.stateOrProvinceList,
    };
}

export function mapDispatchToProps(dispatch) {
    return { submittedListActions: bindActionCreators(SUBMITTED_LIST_ACTIONS, dispatch) };
}
export default connect(mapStateToProps, mapDispatchToProps)(WarrantiesFilters);
